<div class="container py-4">

  <!-- 🔷 TÍTULO -->


  <!-- 🟥 BANNER -->
  <div class="banner-ia">
    <div class="banner-left">
      <img src="assets/banners_carreras/CONTADOR.jpg" alt="IA">
    </div>
  </div>

  <!-- 📘 INFO PRINCIPAL -->
  <section class="info-section">

    <div class="info-block">
      <h3>■ OBJETIVO GENERAL</h3>
      <p>
       Formar profesionales competitivos, capaces de diseñar, establecer, aplicar, controlar y evaluar sistemas de información financiera, administrativa y fiscal, dentro del marco legal vigente para la toma de decisiones de las entidades económicas nacionales e internacionales, con una actitud ética, crítica, emprendedora y de liderazgo, a través de la investigación y el uso de la tecnología de la información y comunicaciones, fomentando el desarrollo sustentable.
    </div>



    <div class="info-block">
      <h3>■ MISIÓN</h3>
      <p>
        Formar profesionales en contaduría pública con sólidos conocimientos, ética y responsabilidad social, capaces de generar información financiera confiable y contribuir al desarrollo económico sostenible de la región sur de Campeche.
    </div>

    <div class="info-block">
      <h3>■ VISIÓN</h3>
      <p>
        En los próximos años, ser una carrera reconocida como una opción innovadora y eficaz en la formación de profesionales en contaduría pública, capaz de responder a los desafíos del entorno y contribuir al desarrollo económico y la formalización del tejido empresarial de Escárcega y el sur de Campeche, mediante soluciones pertinentes, éticas y de alto impacto
      </p>
    </div>

  </section>

  <!-- 🧠 TABS -->
  <div class="tabs-box">

    <ul class="nav nav-tabs">
      <li class="nav-item">
        <button class="nav-link active" data-bs-toggle="tab" data-bs-target="#tab1">
          Perfil de Ingreso
        </button>
      </li>

      <li class="nav-item">
        <button class="nav-link" data-bs-toggle="tab" data-bs-target="#tab2">
          2. Perfil de Egreso
        </button>
      </li>

<!--       <li class="nav-item">
        <button class="nav-link" data-bs-toggle="tab" data-bs-target="#tab3">
          3. Acreditación
        </button>
      </li> -->

      <!--       <li class="nav-item">
        <button class="nav-link" data-bs-toggle="tab" data-bs-target="#tab4">
          4. Atributos de Egreso
        </button>
      </li>

      <li class="nav-item">
        <button class="nav-link" data-bs-toggle="tab" data-bs-target="#tab5">
          5. Acreditación
        </button>
      </li>  -->
    </ul>

    <div class="tab-content">

      <!-- TAB 1 -->
      <div id="tab1" class="tab-pane fade show active">
        
    <p>
      El aspirante a la Licenciatura en Contador Público deberá contar con interés por el área económico-administrativa y disposición para desarrollar habilidades analíticas y numéricas. Se espera que posea conocimientos básicos de matemáticas, comprensión lectora y manejo elemental de tecnologías de la información.
    </p>  <br>
    <p>
      Asimismo, debe mostrar actitudes de responsabilidad, honestidad, disciplina y compromiso social, así como interés por comprender el entorno económico y empresarial de su región. Es deseable que tenga habilidades de comunicación, trabajo en equipo y pensamiento crítico, así como disposición para actuar con ética y apego a normas.
    </p>       
    
    

      </div>

      <!-- TAB 2 -->
      <div id="tab2" class="tab-pane fade">

        <ul>
        <li>Diseña, implanta, controla, evalúa, asesorara e innova sistemas de información financiera, administrativa, fiscal y de auditoría en entidades económicas para la generación, análisis de información financiera con apego a las Normas de Información Financiera, nacionales e internacionales y la toma de decisiones.  </li>
        <li>Audita sistemas financieros, fiscales y administrativos de las entidades económicas con apego a las Normas Internacionales de Auditoria vigentes para la emisión de un dictamen. </li>
        <li>Aplica el marco legal y pertinente a las características y necesidades de la entidad económica dentro del campo profesional para el cumplimiento de las disposiciones vigentes.</li>
        <li>Administra estratégicamente los recursos de las entidades económicas para el cumplimiento de sus objetivos</li>
        <li>Aplica en el ejercicio profesional el código de ética del contador público vigente para enaltecer a la profesión</li>
        <li>Utiliza las tecnologías de información y comunicación para eficiente los procesos y la toma de decisiones. </li>
        <li>Desarrolla investigación asumiendo una actitud de liderazgo, compromiso y servicio con su entorno social, para su difusión.</li>
        <li>Elabora y evalúa proyectos de inversión de acuerdo a las características y necesidades del entorno para la generación de entidades económicas con actitud de liderazgo y compromiso con el medio ambiente. </li>
        <li>Trabaja en equipos multidisciplinarios para el logro de los resultados de las entidades con un sentido de responsabilidad social y visión integradora</li>
        <li>Propone estrategias de mercadotecnia que permitan alcanzar los objetivos de las entidades económicas</li>
        <li>Aplica métodos de análisis de información financiera para determinar las mejores alternativas de inversión y financiamiento</li>
        </ul>
      </div>


      <!--       <div id="tab3" class="tab-pane fade">
        <ul>
           <h5>"Programa Acreditado por el Consejo de Acreditación de Ciencias Administrativas, Contables y Afines, A.C. con vigencia hasta Abril de 2028"

</h5>
            <br>
           <div class="tab-image-wrapper">
            
          <img src="assets/banners_carreras/caceca.png" alt="Información de la carrera" class="tab-image">
        </div>
        </ul>
       

          </div>
 -->

      <!--  <div id="tab4" class="tab-pane fade">
        
        <ul>
          <li>Identifica, formula y resuelve problemas de ingeniería computacional aplicando los principios de las ciencias básicas e ingeniería.</li>
          <li>Aplica metodologías para el análisis y diseño de soluciones tecnológicas que cumplen las necesidades especificadas.</li>
          <li>Desarrolla y conduce proyectos de tecnología computacional y/o científicos para analizar e interpretar datos y utilizar el juicio ingenieril para la toma de decisiones y análisis de resultados.</li>
          <li>Comunica y colabora efectivamente con equipos multidisciplinarios que le permitan analizar, planificar y desarrollar proyectos de tecnología computacional</li>
          <li>Reconoce sus responsabilidades éticas y profesionales al generar soluciones computacionales, en el contexto global, económico, ambiental y social.</li>
          <li>Reconoce la necesidad de actualización en tendencias del ámbito tecnológico que le permita tener la habilidad para localizar, evaluar, integrar y aplicar este conocimiento adecuadamente</li>
          <li>Dirige y/o participa en equipos de trabajo para analizar, planear, gestionar, y ejecutar tareas para el cumplimiento de metas de proyectos de tecnología computacional.</li>
        </ul>
      </div> 


           <div id="tab5" class="tab-pane fade">
              <h5>"Programa Acreditado por el Consejo de Acreditación de la Enseñanza de la Ingeniería con vigencia hasta Diciembre de 2028"</h5>
            <br>
           <div class="tab-image-wrapper">
            
          <img src="assets/banners_carreras/logo cacei.jpg" alt="Información de la carrera" class="tab-image">

     </div>  -->

    </div>

  </div>

  <!--DOCUMENTACIÓN -->
  <div class="doc-section text-center">
    <img src="assets/banners_carreras/logo_drive.png" class="doc-icon">
    <br>
    <a href="https://drive.google.com/drive/folders/https://drive.google.com/drive/folders/1UZYaZ3d_-C9eS_78v19iulNs1KM_Ij_n" target="_blank" class="doc-link">
      ■ DOCUMENTACIÓN CONTADOR PÚBLICO
    </a>
  </div>

  <hr>

  
  <div class="btn-section">

    <a href="assets/reticulas/Reticula Contador Publico.pdf" target="_blank" class="btn-doc">
      📊 Retícula
    </a>
  </div>

  <!-- CONTACTO  -->
  <section class="contact-section">

    <div class="contact-row">

      <div class="contact-card">
        <h3>■ JEFA DE DIVISIÓN</h3>
        <p class="name">Mtra. Araceli Mar Luna</p>
        <p>E-mail: <a href="mailto:divisioncp@itsescarcega.edu.mx">divisioncp@itsescarcega.edu.mx</a></p>
        <P> Telefono:9821084113 </P>
      </div>

      <div class="contact-card">
        <h3>■ COORDINADORA</h3>
        <p class="name">Lic. Adelaida Romero Vera</p>
        <p>E-mail: <a href="mailto:coordinacioncp@itsescarcega.edu.mx">coordinacioncp@itsescarcega.edu.mx</a></p>
         <p> Telefono:9821084113</p> 
      </div>

    </div>

  </section>

</div>